import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";

export class ArkInfoPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, subtitle: string,
                block1: string, block2: string, block3: string, callback: () => unknown, okText: string = Tr('horosho')) {
        super(scene, canvas, title);

        let yy = -170;
        let subtitleText = TextUtils.addTextByFamily(scene, subtitle, 0, yy,
            '#ffd465', 17, 'normal', 300, Fonts.MYRIADPRO_REGULAR);

        let block1Text = TextUtils.addTextAdvanced(scene, block1, -180, yy += 65,
            '#dcd6ff', 12, 'normal', 380, 'left', 2, Fonts.ARIAL_MT);

        let block2Text = TextUtils.addTextAdvanced(scene, block2, -180, yy += 60,
            '#d6f5cb', 12, 'normal', 380, 'left', 2, Fonts.ARIAL_MT);

        let block3Text = TextUtils.addTextAdvanced(scene, block3, -180, yy += 60,
            '#DCD6FFFF', 12, 'normal', 380, 'left', 2, Fonts.ARIAL_MT);

        this.add([subtitleText, block1Text, block2Text, block3Text]);

        this.setOnCLoseCallback(callback);
        this.addCloseButton(okText, () => {});
    }

}
